import { Injectable, signal } from '@angular/core';

@Injectable()
export class PlanogramModes {

	private readonly _articleMode = signal<boolean>(false);
	private readonly _drawBlockMode = signal<boolean>(false);
	private readonly _equipmentEditMode = signal<boolean>(false);
	private readonly _sequenceNumberMode = signal<boolean>(false);
	private readonly _sizesMode = signal<boolean>(false);

	public readonly articleMode = this._articleMode.asReadonly();
	public readonly drawBlockMode = this._drawBlockMode.asReadonly();
	public readonly equipmentEditMode = this._equipmentEditMode.asReadonly();
	public readonly sequenceNumberMode = this._sequenceNumberMode.asReadonly();
	public readonly sizesMode = this._sizesMode.asReadonly();

	public toggleArticleMode() {
		this._articleMode.set(!this._articleMode());
	}

	public setArticleMode(value: boolean) {
		this._articleMode.set(value);
	}

	public toggleDrawBlockMode() {
		this._drawBlockMode.set(!this._drawBlockMode());
	}

	public setDrawBlockMode(value: boolean) {
		this._drawBlockMode.set(value);
	}

	public toggleEquipmentEditMode() {
		this._equipmentEditMode.set(!this._equipmentEditMode());
	}

	public setEquipmentEditMode(value: boolean) {
		this._equipmentEditMode.set(value);
	}

	public toggleSequenceNumberMode() {
		this._sequenceNumberMode.set(!this._sequenceNumberMode());
	}

	public setSequenceNumberMode(value: boolean) {
		this._sequenceNumberMode.set(value);
	}

	public toggleSizesMode() {
		this._sizesMode.set(!this._sizesMode());
	}

	public setSizesMode(value: boolean) {
		this._sizesMode.set(value);
	}
}